import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { createSlice } from '@reduxjs/toolkit';
export var initialState = {
  currentStep: 1,
  reviewStepEnabled: false,
  intlCountries: [],
  selectedMop: undefined
};
var reviewSlice = createSlice({
  name: 'review',
  initialState: initialState,
  reducers: {
    saveReviewData: function saveReviewData(state, _ref) {
      var payload = _ref.payload;
      return _objectSpread(_objectSpread(_objectSpread({}, state), payload), {}, {
        selectedMop: _objectSpread(_objectSpread({}, state.selectedMop), payload.selectedMop)
      });
    }
  }
});
export default reviewSlice.reducer;
var saveReviewData = reviewSlice.actions.saveReviewData;
export { saveReviewData };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/redux/review/review.slice.js
// module id = 504
// module chunks = 11